import { ActionTree } from "vuex";
import { StateInterface } from "src/store";
import { IdomMemStateInterface } from "./state";
import API from "src/services/api/api";
import {
  IDataTemplate,
  IDataTemplateSettings,
  IGptPhrases,
} from "src/modules/idom-mem/models";

const actions: ActionTree<IdomMemStateInterface, StateInterface> = {
  async updateSettings({ commit, dispatch }, settings?: IDataTemplateSettings) {
    try {
      if (settings) {
        commit("resetCounts");
      }
      if (settings) {
        await Promise.all(
          settings.template.map(async (template: IDataTemplate) => {
            const classes = template.classes.map((c) => c.class_guid);
            if (template.type === "img") {
              const count =
                await API.sqlrDataset.data_objects_get_list_sub_count({
                  classes,
                  types: ["78805a22-1a98-8e79-ef3f-42d7c5bfd418"],
                });
              if (!count) {
                throw new Error(`У поля ${template.label} нет картинок`);
              }
              commit("setCount", { count, key: template.label });
            }
            if (template.type === "text") {
              const count =
                await API.sqlrDataset.data_objects_get_list_sub_count({
                  classes,
                  types: ["1cb251ec-0d56-8de6-a929-b520c4aed8d1"],
                });
              if (!count) {
                throw new Error(`У поля ${template.label} нет текстов`);
              }
              commit("setCount", { count, key: template.label });
            }
          }),
        );
      }
      commit("setSettings", settings);
      await dispatch("updateDataForTemplates");
    } catch (e: any) {
      return {
        errorMessage: e.message,
      };
    }
  },
  async updateDataForTemplates({ commit, getters }) {
    try {
      commit("setLoading", true);
      await Promise.all(
        getters.getSettings.template.map(
          async (template: IDataTemplate, idx: number) => {
            if (template.value) {
              commit("setSettingLocalValue", { idx, value: template.value });
              return;
            }
            if (template.type === "img") {
              const offs = Math.floor(
                Math.random() * getters.getCounts[template.label],
              );
              const value = await API.sqlrDataset.data_objects_get_list({
                classes: template.classes.map((c) => c.class_guid),
                types: ["78805a22-1a98-8e79-ef3f-42d7c5bfd418"],
                lim: 1,
                offs,
              });
              commit("setSettingLocalValue", { idx, value: value[0].uri });
            }
            if (template.type === "text") {
              const offs = Math.floor(
                Math.random() * getters.getCounts[template.label],
              );
              if (!template.isCustomText) {
                const value = await API.sqlrDataset.data_objects_get_list({
                  classes: template.classes.map((c) => c.class_guid),
                  types: ["1cb251ec-0d56-8de6-a929-b520c4aed8d1"],
                  lim: 1,
                  offs,
                });
                commit("setSettingLocalValue", { idx, value: value[0].uri });
              } else {
                if (template.isGpt) {
                  const index = getters.getGptPhrases.findIndex(
                    (p: IGptPhrases) => p.text === template.customText,
                  );
                  if (index !== -1) {
                    commit("setSettingLocalValue", {
                      idx,
                      value: getters.getGptPhrases[index].phrases[0],
                    });
                    commit("deleteGptPhrase", template.customText);
                    if (getters.getGptPhrases[index].phrases.length < 6) {
                      if (getters.getLoadingGpt) {
                        return;
                      }
                      commit("setLoadingGpt", true);
                      API.fnc
                        .generator_generate_gpt_nofaq(template.customText)
                        .then((texts) => {
                          commit("setGptPhrases", {
                            text: template.customText,
                            phrases: texts.texts.map(
                              (text: { text: string }) => text.text,
                            ),
                          });
                          commit("setLoadingGpt", false);
                        });
                    }
                    return;
                  }
                  const texts = await API.fnc.generator_generate_gpt_nofaq(
                    template.customText,
                  );
                  commit("setGptPhrases", {
                    text: template.customText,
                    phrases: texts.texts.map(
                      (text: { text: string }) => text.text,
                    ),
                  });
                  commit("setSettingLocalValue", {
                    idx,
                    value:
                      getters.getGptPhrases[getters.getGptPhrases.length - 1]
                        .phrases[0],
                  });
                  commit("deleteGptPhrase", template.customText);
                  return;
                }
                commit("setSettingLocalValue", {
                  idx,
                  value: template.customText,
                });
              }
            }
          },
        ),
      );
    } catch (e) {
    } finally {
      commit("setLoading", false);
    }
  },
};

export default actions;
